import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PartialsModule } from '../../partials/partials.module';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_FORMATS_EDIT } from './datepicker';
import { PopoverModule } from 'ngx-smart-popover';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgbProgressbarModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPrintModule } from 'ngx-print';
import { TreePhanQuyenComponent } from '../components/tree-phan-quyen/tree-phan-quyen.component';
import { TreePhanQuyenNodeComponent } from '../components/tree-phan-quyen-node/tree-phan-quyen-node.component';
// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	MatTooltipModule,
	MatListModule,
	MatChipsModule
} from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from '../../../app.component';
import { PhongHopEditComponent } from './danh-muc/phong-hop/phong-hop-edit/phong-hop-edit.component';
import { DatPhongHopComponent } from './danh-muc/hanh-chanh/dat-phong-hop/dat-phong-hop.component';
import { DatPhongHopEditComponent } from './danh-muc/hanh-chanh/dat-phong-hop-edit/dat-phong-hop-edit.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { HanhChanhService } from './danh-muc/hanh-chanh/hanh-chanh-service/hanh-chanh.service';
import { NhapCapQuanLyDuyetEditComponent } from './quy-trinh/nhap-quy-trinh-duyet/nhap-cap-quan-ly-duyet-edit/nhap-cap-quan-ly-duyet-edit.component';
import { DropdownTreeModule } from 'dps-lib';
import { ChonNhieuNhanVienListComponent } from './components/list-dialog/chon-nhieu-nhan-vien-list/chon-nhieu-nhan-vien-list.component';
import { ChonNhieuFileComponent } from './components/list-dialog/chon-nhieu-file/chon-nhieu-file.component';
import { PopUpComponent } from '../../partials/content/crud';
import { PopUpHuongXuLyComponent } from '../../partials/content/crud';
import { KDDatHangEditComponent } from './kinh-doanh/kd-dat-hang/kd-dat-hang-edit/kd-dat-hang-edit.component';
import { ThongTinXacNhanComponent } from './kinh-doanh/kd-dat-hang/thong-tin-xac-nhan/thong-tin-xac-nhan.component';
import { ThongTinXacNhanFCComponent } from './kinh-doanh/kd-dat-hang/thong-tin-xac-nhan-fc/thong-tin-xac-nhan-fc.component';
import { TimePickerPopupComponent } from 'app/views/partials/content/crud/time-picker-popup/time-picker-popup.component';
@NgModule({
	imports: [
		MatDialogModule,
		CommonModule,
		HttpClientModule,
		PartialsModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule.forChild(),
		MatButtonModule,
		MatMenuModule,
		MatSelectModule,
		MatInputModule,
		MatTableModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatIconModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatPaginatorModule,
		MatSortModule,
		MatCheckboxModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTabsModule,
		MatTooltipModule,
		MatListModule,
		FullCalendarModule,
		// Add List
		PopoverModule,
		NgbProgressbarModule,
		NgbModule,
		NgxPermissionsModule.forChild(),
		NgxMatSelectSearchModule,
		MatChipsModule,
		DropdownTreeModule,
		NgxPrintModule
	],
	providers: [
		{ provide: MAT_DATE_LOCALE, useValue: 'vi' },
		{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
		{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS_EDIT },
		HanhChanhService,
	],
	declarations: [
		PhongHopEditComponent,
		DatPhongHopComponent,
		DatPhongHopEditComponent,
		NhapCapQuanLyDuyetEditComponent,
		ChonNhieuNhanVienListComponent,
		TreePhanQuyenComponent,
		TreePhanQuyenNodeComponent,
		ChonNhieuFileComponent,
		KDDatHangEditComponent,
		ThongTinXacNhanComponent,
		ThongTinXacNhanFCComponent,
		TimePickerPopupComponent
	],
	entryComponents:[
		PopUpComponent,
		PhongHopEditComponent,
		DatPhongHopEditComponent,
		NhapCapQuanLyDuyetEditComponent,
		ChonNhieuNhanVienListComponent,
		TreePhanQuyenComponent,
		TreePhanQuyenNodeComponent,
		PopUpHuongXuLyComponent,
		ChonNhieuFileComponent,
		KDDatHangEditComponent,
		ThongTinXacNhanComponent,
		ThongTinXacNhanFCComponent,
		TimePickerPopupComponent
	],
	exports:[
		DatPhongHopComponent,
		TreePhanQuyenComponent,
		TreePhanQuyenNodeComponent,
		KDDatHangEditComponent,
		ThongTinXacNhanComponent,
		ThongTinXacNhanFCComponent,
		TimePickerPopupComponent
	]
})
export class NFCModule {}
